/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCreate
 */
export interface UserCreate {
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    full_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    role?: UserCreateRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    language?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreate
     */
    invitation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    job_title?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    birth_date?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    department?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    personal_id?: string;
    /**
     * 
     * @type {number}
     * @memberof UserCreate
     */
    supervisor_id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    first_names?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    last_names?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    titles_before?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreate
     */
    titles_after?: string;
}


/**
 * @export
 */
export const UserCreateRoleEnum = {
    Student: 'student',
    Admin: 'admin',
    Owner: 'owner',
    Participant: 'participant'
} as const;
export type UserCreateRoleEnum = typeof UserCreateRoleEnum[keyof typeof UserCreateRoleEnum];


/**
 * Check if a given object implements the UserCreate interface.
 */
export function instanceOfUserCreate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "full_name" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function UserCreateFromJSON(json: any): UserCreate {
    return UserCreateFromJSONTyped(json, false);
}

export function UserCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'full_name': json['full_name'],
        'email': json['email'],
        'role': !exists(json, 'role') ? undefined : json['role'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'invitation': !exists(json, 'invitation') ? undefined : json['invitation'],
        'job_title': !exists(json, 'job_title') ? undefined : json['job_title'],
        'birth_date': !exists(json, 'birth_date') ? undefined : json['birth_date'],
        'department': !exists(json, 'department') ? undefined : json['department'],
        'personal_id': !exists(json, 'personal_id') ? undefined : json['personal_id'],
        'supervisor_id': !exists(json, 'supervisor_id') ? undefined : json['supervisor_id'],
        'first_names': !exists(json, 'first_names') ? undefined : json['first_names'],
        'last_names': !exists(json, 'last_names') ? undefined : json['last_names'],
        'titles_before': !exists(json, 'titles_before') ? undefined : json['titles_before'],
        'titles_after': !exists(json, 'titles_after') ? undefined : json['titles_after'],
    };
}

export function UserCreateToJSON(value?: UserCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'full_name': value.full_name,
        'email': value.email,
        'role': value.role,
        'state': value.state,
        'note': value.note,
        'language': value.language,
        'invitation': value.invitation,
        'job_title': value.job_title,
        'birth_date': value.birth_date,
        'department': value.department,
        'personal_id': value.personal_id,
        'supervisor_id': value.supervisor_id,
        'first_names': value.first_names,
        'last_names': value.last_names,
        'titles_before': value.titles_before,
        'titles_after': value.titles_after,
    };
}

